import { GET_DADOS_RELATORIO } from './mutation-types'

export default {
  [GET_DADOS_RELATORIO]: (state, dadosRelatorio) => {
    state.dadosRelatorio = dadosRelatorio
  },
}
